import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editKeyShout = async ({
	id,
	payload
}: {
	id: number;
	payload: FormData;
}) => {
	const response = await cmsClient.patch<IKeyShout>(
		`/homepage/admin/keyshout/${id}/`,
		payload
	);

	return response.data;
};

const useEditKeyShout = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Key shout updated successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["key-shouts"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(editKeyShout, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useEditKeyShout;
